import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Login from './Authentications/Login';
import { Reset } from './Authentications/Reset';
import { Forgot } from './Authentications/Forgot';
import Register from './Authentications/Register';
import UserComponent from './Authentications/UserComponent';
import UserAccount from './Authentications/UserAccount';
import Dashboard from './Components/Dashboard';

import Sidebar from './Components/Sidebar';
import StudentCount from './Components/students/StudentCount';
import AddStudent from './Components/students/AddStudent';
import StudentDetails from './Components/students/StudentDetails';
import TeachersComponent from './Components/Teachers/TeachersComponent';
import AddTeacher from './Components/Teachers/AddTeachersComponent';
import AddClass from './Components/Classes/AddClass';
import Classes from './Components/Classes/ShowClass';
import ShowFees from './fees/ShowFees';
import AddFees from './fees/AddFees';
import DetailFees from './fees/DetailFees';
import FeesNotPaid from './fees/FeesNotPaid';
import FeesPending from './fees/FeesPending';
import ExpenseList from './Expenses/ExpenseList';
import ExpenseForm from './Expenses/ExpenseForm';
import IncomeExpenseSummary from './income/IncomeExpenseSummary';
import Salaries from './salaries/Salaries';
import AddSalaryForm from './salaries/AddSalaryForm';
import ShowExams from './Exam/ShowExams';
import Marks from './Exam/ShowMarks';
import AddMark from './Exam/AddMark';
import EnterMarks from './Exam/EnterMarks';
import AddExam from './Exam/AddExam';
import ExamConfiguration from './Exam/ExamConfiguration';
import BranchForm from './Branches/BranchForm';
import BranchList from './Branches/BranchList';
import AttendanceTable from './Attendance/AttendanceTable';

import StudentsClass from './Components/students/StudentsClass';
import ShowParents from './Parents/ShowParents';
import CreateParent from './Parents/CreateParent';
import ReportsHub from './Reports/ReportsHub';
import AddmmisionReport from './Reports/AdmmisionReport';
import FeesReport from './Reports/Feesreport';
import IncomeAndExpensesReport from './Reports/IncomeReport';
import AttendanceReport from './Reports/AttendanceReport';
import StudentReport from './Reports/StudentReport';
import Sections from './Components/Sections/Section';
import AddSection from './Components/Sections/AddSection';
import DisciplineComponent from './Disciplines/Discipline';
import ParentDashboard from './Components/ParentDashboard';
import AttendaceDashboard from './Attendance/AttendaceDashboard';
import FeeStructureComponent from './fees/FeesStructure';
import BlogPostCRUD from './Components/Posts/BlogPost';
import PostList from './Components/Posts/Posts';
import PostDetail from './Components/Posts/PostDetail';
import Subjects from './Exam/Subjects';
import GradingSystems from './Exam/GradingSystems';
import AuthGuard from './Components/AuthGuard';
import NotFound from './Components/NotFound';


function MyLayout() {
    const location = useLocation();
    const isFullPage = ['/', '/forgot', '/register', '/parent-dashboard'].includes(location.pathname) || location.pathname.startsWith('/reset');

    return (
        <>
            {/* {(location.pathname !== '/' && location.pathname !== '/forgot' && location.pathname !== '/pos') && <Nav />} */}
            {!isFullPage && <Sidebar />}
            <div className={!isFullPage ? "main-content-wrapper" : ""}>
                <Routes>
                    {/* Public Routes */}
                    <Route path="/" element={<Login />} />
                    <Route path="/reset/:token" element={<Reset />} />
                    <Route path="/forgot" element={<Forgot />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/parent-dashboard" element={<ParentDashboard />} />

                    {/* Protected Routes */}
                    <Route element={<AuthGuard />}>
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/xarun" element={<BranchList />} />
                        <Route path="/kudar-xarun" element={<BranchForm />} />
                        {/* Students */}

                        <Route path="/students" element={<StudentCount />} />
                        <Route path="/classOfStudent" element={<StudentsClass />} />
                        <Route path='/student-details/:id' element={<StudentDetails />} />
                        <Route path="/add-students" element={<AddStudent />} />
                        {/* Users */}

                        <Route path="/users" element={<UserComponent />} />
                        <Route path="/account" element={<UserAccount />} />
                        {/* Teachers */}

                        <Route path="/teachers" element={<TeachersComponent />} />
                        <Route path="/add-teachers" element={<AddTeacher />} />
                        {/* financials */}

                        <Route path="/fees" element={<ShowFees />} />
                        <Route path="/fees-structure" element={<FeeStructureComponent />} />
                        <Route path="/add-fees" element={<AddFees />} />
                        <Route path='/:id/' element={<DetailFees />} />
                        <Route path="/income" element={<IncomeExpenseSummary />} />
                        <Route path="/ExpenseList" element={<ExpenseList />} />
                        <Route path="/expenses" element={<ExpenseForm />} />
                        <Route path="/salaries" element={<Salaries />} />
                        <Route path="/fees_not_paid" element={<FeesNotPaid />} />
                        <Route path="/fees-pending" element={<FeesPending />} />
                        <Route path="/add-salary" element={<AddSalaryForm />} />
                        {/* Exams  */}

                        <Route path="/exams" element={<ShowExams />} />
                        <Route path="/marks" element={<Marks />} />
                        <Route path="/add-marks" element={<AddMark />} />
                        <Route path="/enter-marks" element={<EnterMarks />} />
                        <Route path="/subjects" element={<Subjects />} />
                        <Route path="/gradings" element={<GradingSystems />} />
                        <Route path="/exam-configuration" element={<ExamConfiguration />} />
                        <Route path="/add-exam" element={<AddExam onSuccess={() => { }} />} />
                        {/* Branches */}

                        {/* <Route path="/mustaqbal" element={<Mustaqbal/>} />
                      <Route path="/bayan" element={<Bayan/>} /> */}
                        {/* Classes */}
                        <Route path="/classes" element={<Classes />} />
                        <Route path="/add-classes" element={<AddClass />} />
                        {/* <Section></Section> */}
                        <Route path="/section" element={<Sections />} />
                        <Route path="/add-section" element={<AddSection />} />

                        {/* Attendances*/}
                        {/* StudentItem */}

                        <Route path="/attendance" element={<AttendanceTable />} />
                        <Route path="/attendance-table" element={<AttendanceTable />} />
                        <Route path="/attendance-dashboard" element={<AttendaceDashboard />} />
                        {/* Parenst */}

                        <Route path="/parents" element={<ShowParents />} />
                        <Route path="/add-parent" element={<CreateParent />} />
                        {/* Reports */}

                        <Route path="/reports" element={<ReportsHub />} />
                        <Route path="/admission-report" element={<AddmmisionReport />} />
                        <Route path="/addmision_report" element={<AddmmisionReport />} />
                        <Route path="/fees-report" element={<FeesReport />} />
                        <Route path="/income-report" element={<IncomeAndExpensesReport />} />
                        <Route path="/attendance-report" element={<AttendanceReport />} />
                        <Route path="/student-report" element={<StudentReport />} />

                        {/* discipline */}
                        <Route path="/discipline" element={<DisciplineComponent />} />
                        <Route path="/post" element={<BlogPostCRUD />} />
                        <Route path="/post-list" element={<PostList />} />
                        <Route path="/posts/:id" element={<PostDetail />} />
                    </Route>

                    {/* Catch all - 404 */}
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </div>
        </>

    );
}

function App() {
    return (

        <BrowserRouter>
            <MyLayout />
        </BrowserRouter>
    )
}

export default App;
